export default [
  {
    id: 1,
    device: "Device 1",
    nickname: 'asperiores',
    signalstrength: '2',
    salary: '€ 13098.00',
    age: 39
  },
  {
    id: 2,
    device: 'Device 2',
    nickname: 'alias',
    signalstrength: require("@/assets/img/signal0.png"),
    salary: '€ 35978.00',
    age: 26
  },
  {
    id: 3,
    device: 'Device 3',
    nickname: 'id',
    signalstrength: 'little.myrna@example.net',
    salary: '€ 26278.00',
    age: 48
  },
  {
    id: 4,
    device: 'Device 5',
    nickname: 'vel',
    signalstrength: 'dock47@example.org',
    salary: '€ 25537.00',
    age: 27
  },
  {
    id: 5,
    device: 'Device 6',
    nickname: 'qui',
    signalstrength: 'ugrady@example.org',
    salary: '€ 49003.00',
    age: 21
  },
  {
    id: 6,
    device: 'Ms. Crystel Zemlak IV',
    nickname: 'reiciendis',
    signalstrength: 'amari.rau@example.com',
    salary: '€ 12383.00',
    age: 48
  },
  {
    id: 7,
    device: 'Nona McDermott',
    nickname: 'quaerat',
    signalstrength: 'adrien.baumbach@example.org',
    salary: '€ 18512.00',
    age: 31
  },
  {
    id: 8,
    device: 'Miss Genoveva Murazik V',
    nickname: 'rerum',
    signalstrength: 'ohettinger@example.net',
    salary: '€ 31209.00',
    age: 28
  },
  {
    id: 9,
    device: 'Beulah Huels',
    nickname: 'non',
    signalstrength: 'stefan99@example.com',
    salary: '€ 36920.00',
    age: 53
  },
  {
    id: 10,
    device: 'Zoe Klein',
    nickname: 'ex',
    signalstrength: 'ejacobson@example.org',
    salary: '€ 35616.00',
    age: 27
  },
  {
    id: 11,
    device: 'Vickie Kiehn',
    nickname: 'assumenda',
    signalstrength: 'ayost@example.com',
    salary: '€ 30790.00',
    age: 29
  },
  {
    id: 12,
    device: 'Elwyn Herzog',
    nickname: 'praesentium',
    signalstrength: 'ckassulke@example.net',
    salary: '€ 35785.00',
    age: 27
  },
  {
    id: 13,
    device: 'Selena Hettinger',
    nickname: 'et',
    signalstrength: 'bashirian.hyman@example.net',
    salary: '€ 31836.00',
    age: 35
  },
  {
    id: 14,
    name: 'Edwin Beier',
    nickname: 'eos',
    signalstrength: 'janis71@example.org',
    salary: '€ 11902.00',
    age: 38
  },
  {
    id: 15,
    name: 'Lexi Braun MD',
    nickname: 'autem',
    signalstrength: 'dusty74@example.net',
    salary: '€ 11927.00',
    age: 45
  },
  {
    id: 16,
    name: 'Jovany Spencer',
    nickname: 'fugit',
    signalstrength: 'gbogisich@example.org',
    salary: '€ 44686.00',
    age: 43
  },
  {
    id: 17,
    name: 'Prof. Maci Anderson DVM',
    nickname: 'dolorem',
    signalstrength: 'btorp@example.com',
    salary: '€ 25055.00',
    age: 29
  },
  {
    id: 18,
    name: 'Joel Kulas MD',
    nickname: 'sed',
    signalstrength: 'phoebe.sauer@example.org',
    salary: '€ 11650.00',
    age: 24
  },
  {
    id: 19,
    name: 'Mr. Dawson Greenholt',
    nickname: 'nostrum',
    signalstrength: 'asawayn@example.org',
    salary: '€ 46962.00',
    age: 53
  },
  {
    id: 20,
    name: 'Prof. Lloyd Green',
    nickname: 'velit',
    signalstrength: 'laila.hintz@example.org',
    salary: '€ 12928.00',
    age: 46
  },
  {
    id: 21,
    name: 'Shayna Morar',
    nickname: 'rerum',
    signalstrength: 'wfay@example.org',
    salary: '€ 22638.00',
    age: 26
  },
  {
    id: 22,
    name: 'Krista Schulist',
    nickname: 'qui',
    signalstrength: 'gregoria.jakubowski@example.com',
    salary: '€ 49345.00',
    age: 42
  },
  {
    id: 23,
    name: 'Leone Lemke',
    nickname: 'repellat',
    signalstrength: 'ltorphy@example.com',
    salary: '€ 17560.00',
    age: 42
  },
  {
    id: 24,
    name: 'Dr. Willie Kemmer II',
    nickname: 'quasi',
    signalstrength: 'ivy51@example.net',
    salary: '€ 35370.00',
    age: 30
  },
  {
    id: 25,
    name: 'Deonte Lebsack',
    nickname: 'nesciunt',
    signalstrength: 'alisa83@example.net',
    salary: '€ 32725.00',
    age: 24
  },
  {
    id: 26,
    name: 'Prof. Shayne Nader',
    nickname: 'voluptas',
    signalstrength: 'bosco.shaina@example.net',
    salary: '€ 9844.00',
    age: 23
  },
  {
    id: 27,
    name: 'Prof. Kennith Kertzmann',
    nickname: 'alias',
    signalstrength: 'satterfield.jonathan@example.com',
    salary: '€ 41950.00',
    age: 25
  },
  {
    id: 28,
    name: "Miss Meagan O'Keefe",
    nickname: 'corporis',
    signalstrength: 'tracy.barrows@example.com',
    salary: '€ 41803.00',
    age: 50
  },
  {
    id: 29,
    name: 'Prof. Edward Pagac MD',
    nickname: 'quia',
    signalstrength: 'gerhard65@example.org',
    salary: '€ 22896.00',
    age: 43
  },
  {
    id: 30,
    name: 'Samantha Weissnat',
    nickname: 'est',
    signalstrength: 'crystel66@example.net',
    salary: '€ 18805.00',
    age: 43
  },
  {
    id: 31,
    name: 'Dr. Gilbert Ward',
    nickname: 'dolorum',
    signalstrength: 'sandrine06@example.net',
    salary: '€ 16644.00',
    age: 32
  },
  {
    id: 32,
    name: 'Mike West',
    nickname: 'laudantium',
    signalstrength: 'jborer@example.net',
    salary: '€ 35728.00',
    age: 42
  },
  {
    id: 33,
    name: 'Prof. Isabell Cruickshank I',
    nickname: 'recusandae',
    signalstrength: 'ondricka.lurline@example.org',
    salary: '€ 44574.00',
    age: 35
  },
  {
    id: 34,
    name: 'Prof. Lonny Rath',
    nickname: 'nihil',
    signalstrength: 'rfeest@example.net',
    salary: '€ 19949.00',
    age: 48
  },
  {
    id: 35,
    name: 'Santina Medhurst MD',
    nickname: 'suscipit',
    signalstrength: 'ila24@example.net',
    salary: '€ 36323.00',
    age: 51
  },
  {
    id: 36,
    name: 'Jeff Lehner',
    nickname: 'quo',
    signalstrength: 'jarred77@example.com',
    salary: '€ 48462.00',
    age: 42
  },
  {
    id: 37,
    name: 'Samanta Pfeffer',
    nickname: 'officia',
    signalstrength: 'fgoyette@example.net',
    salary: '€ 19601.00',
    age: 42
  },
  {
    id: 38,
    name: 'Ofelia Torp',
    nickname: 'a',
    signalstrength: 'ericka44@example.net',
    salary: '€ 33149.00',
    age: 35
  },
  {
    id: 39,
    name: 'Mrs. Margarete Raynor',
    nickname: 'quia',
    signalstrength: 'jlegros@example.net',
    salary: '€ 21951.00',
    age: 40
  },
  {
    id: 40,
    name: 'Mr. Brant Howell V',
    nickname: 'perspiciatis',
    signalstrength: 'franecki.gerald@example.org',
    salary: '€ 41552.00',
    age: 53
  },
  {
    id: 41,
    name: 'Reilly Ruecker DVM',
    nickname: 'ad',
    signalstrength: 'ldeckow@example.net',
    salary: '€ 22709.00',
    age: 42
  },
  {
    id: 42,
    name: 'Zachery McDermott',
    nickname: 'molestiae',
    signalstrength: 'gladyce84@example.com',
    salary: '€ 32354.00',
    age: 25
  },
  {
    id: 43,
    name: 'Heloise Kulas',
    nickname: 'aut',
    signalstrength: 'kessler.helen@example.net',
    salary: '€ 45086.00',
    age: 54
  },
  {
    id: 44,
    name: 'Norma Dibbert',
    nickname: 'amet',
    signalstrength: 'eudora36@example.net',
    salary: '€ 15661.00',
    age: 46
  },
  {
    id: 45,
    name: 'Immanuel Auer',
    nickname: 'quia',
    signalstrength: 'halvorson.theodora@example.org',
    salary: '€ 15862.00',
    age: 39
  },
  {
    id: 46,
    name: 'Lamont Borer',
    nickname: 'expedita',
    signalstrength: 'trantow.neoma@example.com',
    salary: '€ 12544.00',
    age: 25
  },
  {
    id: 47,
    name: 'Brooke Purdy',
    nickname: 'cupiditate',
    signalstrength: 'bhermiston@example.net',
    salary: '€ 14457.00',
    age: 50
  },
  {
    id: 48,
    name: 'Dr. Leo Dach',
    nickname: 'et',
    signalstrength: 'camila.ward@example.com',
    salary: '€ 40278.00',
    age: 49
  },
  {
    id: 49,
    name: 'Krystal Langosh',
    nickname: 'voluptatum',
    signalstrength: 'pacocha.yesenia@example.org',
    salary: '€ 9305.00',
    age: 34
  },
  {
    id: 50,
    name: 'Florence Greenfelder',
    nickname: 'odit',
    signalstrength: 'kenyatta.oconnell@example.com',
    salary: '€ 36980.00',
    age: 38
  }
];
